import React from 'react';
import { BottomNavigation } from 'react-native-paper';
import BagsTab from './BagsTab';
import EquipmentsTab from './EquipmentsTab';

function ManageEquipmentScreen() {
  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    {
      key: 'bags', title: 'Sacs', focusedIcon: 'bag-personal', unfocusedIcon: 'bag-personal-outline',
    },
    {
      key: 'equipments', title: 'Equipements', focusedIcon: 'boxing-glove', unfocusedIcon: 'boxing-glove',
    },
  ]);

  const renderScene = BottomNavigation.SceneMap({
    bags: BagsTab,
    equipments: EquipmentsTab,
  });

  return (
    <BottomNavigation
      navigationState={{ index, routes }}
      onIndexChange={setIndex}
      renderScene={renderScene}
    />
  );
}

export default ManageEquipmentScreen;
